import React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { MyPageController } from "./MyPage"
import { DiagRedirector, FMatControlPage } from "./diag"
import { PaperResultPage } from "./paper"
import Error404 from "./Error404"
import InputCodePage from "./login/InputCode"
import InputProfilePage from "./login/InputProfile"
import RootRedirector from "./RootRedirector"
import CodeAuthRedirector from "./login/CodeAuthRedirector"
import DinoRouter from "./dino/DinoRouter"
import MyPage from "./dino/MyPage"

export default () => (
  <Router>
    <Routes>
      <Route path="/" element={<RootRedirector />} />
      <Route path="/login" element={<InputCodePage />} />
      <Route path="/login/:code" element={<CodeAuthRedirector />} />
      <Route path="/login/:code/profile" element={<InputProfilePage />} />
      <Route path="/my_old" element={<MyPageController />} />
      <Route path="/my" element={<MyPage />} />
      <Route path="/paper/:paperId" element={<DiagRedirector />} />
      <Route path="/paper/:paperId/diag" element={<FMatControlPage />} />
      <Route path="/paper/:paperId/result" element={<PaperResultPage />} />
      <Route path="/papers/:paperId/*" element={<DinoRouter />} />
      <Route path="/public/:rcode/papers/:paperId/result" element={<PaperResultPage />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  </Router>
)
